import axios from 'axios'
const api=  process.env.VUE_APP_API_BACKOFFICE_URL
let axx;
if (window.localStorage.token_backoffice) {
   axx= axios.create({
    baseURL: api,
    timeout: 100000,
    headers: {
      'Authorization':'Bearer ' + window.localStorage.token_backoffice
    },})
}else{
   axx=  axios.create({
    baseURL: api,
    timeout: 100000,
    headers: {
    },})
}

export default  axx;
